<template>
  <div>
    <div v-loading="treeLoading">
      <Tree :data="OrganizationData" :render="renderContent" class="demo-tree-render"></Tree>
      <Modal v-model="OrganizationModalIsShow"
             title="节点编辑">
        <Form :model="OrganizationFrom" :rules="OrganizationRules" ref="OrganizationRefs">
          <FormItem label="机构名称">
            <Input v-model="OrganizationFrom.name"></Input>
          </FormItem>
          <!--          <FormItem label="机构人员">-->
          <!--            <Select v-model="OrganizationFrom.personel" multiple>-->
          <!--              <Option v-for="(item,index) in personelList" :key="index" :label="item.familyName+item.name"-->
          <!--                      :value="item.userId"></Option>-->
          <!--            </Select>-->
          <!--          </FormItem>-->
        </Form>
        <div slot="footer">
          <Button @click="OrganizationModalIsShow = false">取消</Button>
          <Button type="primary" @click="addOrganization" :loading="addOrganizationBtnLoading">确定
          </Button>
        </div>
      </Modal>
      <Modal v-model="removeModalIsShow" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>删除组织</span>
        </p>
        <div style="text-align:center">
          <p>删除组织会删除本组织及下属组织，数据不可恢复</p>
          <p>确定删除?</p>
        </div>
        <div slot="footer">
          <Button type="error" size="large" long :loading="removeBtnloading" @click="removeOrganization">删除</Button>
        </div>
      </Modal>
      <Modal v-model="removePersonModalIsShow" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>删除人员</span>
        </p>
        <div style="text-align:center">
          <p>删除此人，数据不可恢复，请谨慎删除</p>
          <p>确定删除?</p>
        </div>
        <div slot="footer">
          <Button type="error" size="large" long :loading="removePersonBtnloading" @click="removePerson">删除</Button>
        </div>
      </Modal>
      <Modal v-model="personalModalIsShow"
             title="人员添加">
        <Form :model="personalFrom" :rules="personalRules" ref="personalRefs">
          <FormItem label="机构名称">
            <Input v-model="personalFrom.name" disabled></Input>
          </FormItem>
          <FormItem label="机构人员">
            <Select v-model="personalFrom.personel" multiple filterable>
              <Option v-for="(item,index) in personelList" :key="index" :label="item.name"
                      :value="item.userId"></Option>
            </Select>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="personalModalIsShow = false">取消</Button>
          <Button type="primary" @click="addPersonal" :loading="addPersonalBtnLoading">确定
          </Button>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: 'Organization',
  data() {
    return {
      removePersonModalIsShow: false, // 删除人员弹窗
      removePersonBtnloading: false, // 删除人员按钮loading
      addPersonalBtnLoading: false, // 添加人员按钮loading
      personalModalIsShow: false, // 添加节点弹窗
      removeBtnloading: false, // 删除节点按钮loading
      personelList: [], // 人员列表
      treeLoading: false,
      removeModalIsShow: false, // 删除节点弹窗
      currentOrganizationNode: {}, // 当前选中的节点
      addOrganizationBtnLoading: false, // 添加节点按钮loading
      OrganizationModalIsShow: false, // 添加节点弹窗
      OrganizationData: [], //  组织架构数据
      OrganizationFrom: {
        name: '',
        personel: ''
      }, // 添加节点表单
      OrganizationRules: {
        name: [
          {required: true, message: '请输入节点名称', trigger: 'blur'}
        ]
      },
      personalFrom: {
        name: '',
        personel: ''
      }, // 添加节点表单
      personalRules: {
        name: [
          {required: true, message: '请输入节点名称', trigger: 'blur'}
        ]
      },
      buttonProps: {
        type: 'default',
        size: 'small',
      }
    }
  },
  mounted() {
    this.getOrganizationData();
    // this.getPersonelList()
  },
  methods: {
    renderContent(h, {root, node, data}) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [
        h('span', [
          // h('span', data.title + data.indexCode + '_' + data.parentIndexCode + '_' + data.unitLevel + '_' + data.parentLabel),
          h('span', [
            h('span', {
              style: {
                marginLeft: '8px',
                lineHeight: '26px',
              }
            }, data.title),
            h('Icon', {
              props: {
                type: 'ios-contact',
                size: 18
              },
              style: {
                marginLeft: '8px',
                lineHeight: '26px',
                display: data.unitLevel === 9999 ? 'inline-block' : 'none'
              }
            }),
          ]),
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '32px'
          }
        }, [
          h('Button', {
            props: Object.assign({}, this.buttonProps, {
              icon: 'ios-add'
            }),
            style: {
              marginRight: '8px',
              display: data.unitLevel === 9999 ? 'none' : 'inline-block'
            },
            on: {
              click: () => {
                this.append(data)
              }
            }
          }),
          h('Button', {
            style: {
              marginRight: data.unitLevel === 9999 ? '0' : '8px'
            },
            props: Object.assign({}, this.buttonProps, {
              icon: 'ios-remove'
            }),
            on: {
              click: () => {
                this.remove(root, node, data)
              }
            }
          }),
          h('Button', {
            props: Object.assign({}, this.buttonProps, {
              icon: 'ios-contact'
            }),
            style: {
              display: data.unitLevel === 9999 ? 'none' : 'inline-block'
            },
            on: {
              click: () => {
                this.edit(root, node, data)
              }
            }
          })
        ])
      ]);
    },
    getPersonelList() {
      this.$http.get('/api/getNotDeptUserList').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.personelList = res.data;
        }
      })
    },
    getOrganizationData() {
      this.treeLoading = true;
      this.$http.get('/api/depts?page=1&size=99999').then(res => {
        if (res.status === 200) {
          this.treeLoading = false;
          let data = res.data.data;
          data = data.map(item => {
            return {
              title: item.name,
              indexCode: item.indexCode,
              parentIndexCode: item.parentIndexCode,
              unitLevel: item.unitLevel,
              parentLabel: item.parentLabel,
              id: item.id,
              expand: item.unitLevel <= 3
            }
          })
          this.OrganizationData = this.dataTree(data);
        }
      })
    },
    // 平面数据转树形结构，递归
    dataTree(list, rootValue = '0') {
      let arr = []
      list && list.forEach(item => {
        if (item.parentIndexCode === rootValue) {
          // 要去找这个item它的子级  item.id = 子级的relation
          arr.push(item) // 如果找到了item 先把它放到数组中
          const child = this.dataTree(list, item.indexCode)
          if (child.length) {
            // 表示了找到了子元素
            item.children = child
          }
        }
      })
      return arr
    },
    append(data) {
      this.currentOrganizationNode = data;
      this.OrganizationModalIsShow = true;
    },
    addOrganization() {
      this.$refs.OrganizationRefs.validate((valid) => {
        if (valid) {
          this.addOrganizationBtnLoading = true;
          let request = {
            name: this.OrganizationFrom.name,
            parentIndexCode: this.currentOrganizationNode.indexCode,
            indexCode: Date.parse(new Date()),
            parentLabel: parseInt(this.currentOrganizationNode.parentLabel) + 1,
            unitLevel: parseInt(this.currentOrganizationNode.unitLevel) + 1
          }
          console.log(request)
          this.$http.post('/api/depts', request).then(res => {
            console.log(res)
            if (res.status === 201) {
              this.$Message.success('添加成功');
              this.OrganizationModalIsShow = false;
              this.getOrganizationData();
            }
            this.addOrganizationBtnLoading = false;
          })
        }
      })
    },
    remove(root, node, data) {
      this.currentOrganizationNode = data;
      if (data.unitLevel === 9999) {
        this.removePersonModalIsShow = true;
      } else {
        this.removeModalIsShow = true;
      }
    },
    removeOrganization() {
      this.removeBtnloading = true;
      this.$http.delete(`/api/depts/${this.currentOrganizationNode.id}`).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.removeBtnloading = false
          this.$Message.success('删除成功');
          this.removeModalIsShow = false;
          this.getOrganizationData();
        } else {
          this.$Message.error('删除失败')
        }
      })
    },
    removePerson() {
      this.removePersonBtnloading = true;
      this.$http.delete(`/api/userCountyStreetDeptRelations/${this.currentOrganizationNode.id}`).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.removePersonBtnloading = false
          this.$Message.success('删除成功');
          this.removePersonModalIsShow = false;
          this.getOrganizationData();
        } else {
          this.$Message.error('删除失败')
        }
      })
    },
    edit(root, node, data) {
      this.currentOrganizationNode = data;
      this.personalModalIsShow = true;
      this.personalFrom = data
      this.personalFrom.name = data.title
      this.getPersonelList()
    },
    addPersonal() {
      this.addPersonalBtnLoading = true;
      let request = []
      for (let i of this.personalFrom.personel) {
        request.push({
          unitId: this.currentOrganizationNode.indexCode,
          userId: i
        })
      }
      this.$http.post('/api/insertDeptUsers ', request).then(res => {
        if (res.status === 200) {
          this.$Message.success('添加成功');
          this.addPersonalBtnLoading = false;
          this.personalModalIsShow = false;
          this.getOrganizationData();
        }
      })
    }
  }
}
</script>
<style>
.demo-tree-render .ivu-tree-title {
  width: 100%;
}
</style>
